<template>
  <adv-setup :config="setupConfigResources" :key="key" v-if="loaded" class="adv-setup-textarea">
    <adv-text-area v-bind="allProps" @setupTiny="setupTiny" />
  </adv-setup>
</template>

<script>
import { Route } from '@/epersonam/route.js';
import { advTextArea } from '§/components/textArea';
import apiConnector from '@/epersonam/apiConnector';

export default {
  name: 'vtextarea',
  components: {
    advTextArea,
  },
  props: {
    id: { type: String, required: true },
    formId: { type: String, default: '' },
    initExtend: { type: Object, required: false },
    value: { type: String, required: false, default: '' },
    hasToolbar: { type: Boolean, required: false, default: true },
    hasCapture: { type: Boolean, required: false, default: false },
    attribute: { type: String, required: false },
    name: { type: String, required: false },
    disabled: { type: Boolean, default: false },
    hasVariable: { type: Boolean, default: false },
    hasRecoverText: { type: Boolean, default: false },
    hasAutoResize: { type: Boolean, default: true },
    customButtonOptions: { type: Object, default: () => {} },
    classesTextarea: { type: String, required: false },
    hasResolveVariablesButton: { type: Boolean, default: false },
    concurrency: { type: Boolean, default: true },
    cleanText: { type: Boolean, default: false },
    cleanTextLanding: { type: Boolean, default: false },
    customIcons: {
      type: Array,
      default: () => {
        const defaultIcons = [
          {
            name: 'thumbtack',
            class: 'fal fa-thumbtack',
          },
          {
            name: 'leftfromline',
            class: 'fal fa-left-from-line',
          },
        ];
        return defaultIcons;
      },
    },
  },
  data() {
    return {
      loaded: false,
      editor: null,
      currentValue: null,
      allProps: {
        decodesValuesUrl: `${window.config.ePersonamService.ePersonamHost}${Route.DECODES_CONFIG_GET_VALUES}`,
        requirementsUrl: `${window.config.ePersonamService.ePersonamHost}${Route.REPORT_TEMPLATE}/requirements.json`,
        labels: {
          insert_text: window.i18nJS.insert_text,
          go_to_decodes: window.i18nJS.go_to_decodes,
        },
      },
      key: 'setup-text-1',
      setupConfigResources: {
        globalData: {
          user: {
            super: window.config.user.super,
          },
          businessUnit: {
            id: window.config.business_unit.id,
          },
        },
      },
    };
  },
  watch: {
    value: function (val, prevVal) {
      // use it to change programmaticaly v-model (example: preview area)
      if (this.editor && typeof val === 'string' && val !== this.currentValue && val !== prevVal) {
        this.editor.setContent(val);
        this.currentValue = val;
      }
    },
  },
  mounted() {
    this.allProps = {
      ...this.$props,
      ...this.allProps,
    };
    this.openDecodesEvent();
    this.loaded = true;
  },
  destroyed() {
    this.adv_common.offEvent(`openDecodesPopup::editor::${this.id}`, this.openDecodesFn);
  },
  methods: {
    setupTiny(editor) {
      this.editor = editor;
      this.$emit(`setup::${this.id}`, editor);
      this.$emit(`genericSetup`, editor);
      editor.on('change keyup undo redo', () => {
        this.currentValue = editor.getContent();
        this.$emit('input', editor.getContent());
        eventBus.$emit('usersInteractions');
      });
      this.customEvents(editor);
    },
    customEvents(editor) {
      editor.on('init', (e) => {
        const formContainer = document.querySelector(`#${this.id}`).closest('form');
        if (formContainer) {
          eventBus.$emit('form-changed-neatly', { id: formContainer.id });
        }
        eventBus.$emit('init-vtextarea', { editor: editor, id: this.id, value: editor.getContent(), name: this.name });
      });
    },
    openDecodesEvent() {
      this.adv_common.onEvent(`openDecodesPopup::editor::${this.id}`, this.openDecodesFn);
    },
    async openDecodesFn() {
      Loader.show();
      const result = await apiConnector().get(
        `${Route.DECODES_CONFIG}.js?business_unit_id=${window.config.business_unit.id}&cod=custom_text_decoded&key=generale`,
      );
      eval(result.data);
    },
  },
};
</script>

<style lang="scss">
.adv-setup-textarea {
  height: 100%;
}
</style>
